import { ContextGLBlendFactor } from '../base/ContextGLBlendFactor';
var FilterBase = /** @class */ (function () {
    function FilterBase() {
        this._tasks = [];
        this._temp = [];
    }
    Object.defineProperty(FilterBase.prototype, "requireBlend", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterBase.prototype, "blendDst", {
        get: function () {
            return ContextGLBlendFactor.ZERO;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterBase.prototype, "blendSrc", {
        get: function () {
            return ContextGLBlendFactor.ONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterBase.prototype, "requireDepthRender", {
        get: function () {
            return this._requireDepthRender;
        },
        enumerable: false,
        configurable: true
    });
    FilterBase.prototype.addTask = function (filter) {
        this._tasks.push(filter);
        if (this._requireDepthRender == null)
            this._requireDepthRender = filter.requireDepthRender;
    };
    Object.defineProperty(FilterBase.prototype, "tasks", {
        get: function () {
            return this._tasks;
        },
        enumerable: false,
        configurable: true
    });
    // link up the filters correctly with the next filter
    FilterBase.prototype.setRenderState = function (source, mainTarget, sourceRect, destRect, filterManage) {
        this._tasks[0].inputRect = sourceRect;
        this._tasks[0].source = source;
        this._tasks[this._tasks.length - 1].destRect = destRect;
        this._tasks[this._tasks.length - 1].target = mainTarget;
    };
    FilterBase.prototype.dispose = function () {
        for (var i = 0; i < this._tasks.length; ++i)
            this._tasks[i].dispose();
    };
    FilterBase.prototype.update = function (stage, projection) {
    };
    FilterBase.prototype.clear = function (_manage) {
        this._temp.forEach(function (e) { return _manage.pushTemp(e); });
        this._temp.length = 0;
    };
    return FilterBase;
}());
export { FilterBase };
